/*
 * Discount code block — copy-to-clipboard.
 *
 * One delegated listener on the document, registered at most once per page.
 * Quick View injects its HTML with innerHTML (which never executes <script>),
 * so binding per-instance would either never run or would re-bind on every open.
 * Delegation makes the block work for markup that appears after load, survives
 * repeated Quick View opens, and survives shopify:section:load in the editor.
 *
 * No Alpine, no jQuery, no polling, no globals beyond the theme's own guard.
 */
(function () {
  'use strict';

  var FLAG = '__discountCodeBlockBound';
  if (window[FLAG]) return;

  // Follow the theme's existing duplicate-load guard where it is available.
  if (window.Maximize && Array.isArray(window.Maximize.loadedScript)) {
    if (window.Maximize.loadedScript.indexOf('discount-code-block.js') !== -1) return;
    window.Maximize.loadedScript.push('discount-code-block.js');
  }
  window[FLAG] = true;

  var REVERT_MS = 2500;
  var timers = new WeakMap();

  function legacyCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '-9999px';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    var selection = document.getSelection();
    var previous = selection && selection.rangeCount > 0 ? selection.getRangeAt(0) : null;
    ta.select();
    ta.setSelectionRange(0, ta.value.length);
    var ok = false;
    try {
      ok = document.execCommand('copy');
    } catch (e) {
      ok = false;
    }
    document.body.removeChild(ta);
    if (previous && selection) {
      selection.removeAllRanges();
      selection.addRange(previous);
    }
    return ok;
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).then(
        function () { return true; },
        function () { return legacyCopy(text); }
      );
    }
    return Promise.resolve(legacyCopy(text));
  }

  function confirm(button) {
    var card = button.closest('[data-dcb-block]');
    var label = button.querySelector('[data-dcb-label]');
    var live = card ? card.querySelector('[data-dcb-live]') : null;
    var copiedLabel = button.getAttribute('data-dcb-copied-label') || '';
    var copyLabel = button.getAttribute('data-dcb-copy-label') || '';

    if (label) label.textContent = copiedLabel;
    button.setAttribute('data-dcb-copied', 'true');
    // Announce to assistive tech. Cleared first so a repeat copy re-announces.
    if (live) {
      live.textContent = '';
      window.requestAnimationFrame(function () { live.textContent = copiedLabel; });
    }

    var existing = timers.get(button);
    if (existing) clearTimeout(existing);
    timers.set(
      button,
      setTimeout(function () {
        if (label) label.textContent = copyLabel;
        button.removeAttribute('data-dcb-copied');
        if (live) live.textContent = '';
        timers.delete(button);
      }, REVERT_MS)
    );
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var button = target.closest('[data-dcb-copy]');
    if (!button) return;

    event.preventDefault();

    // The exact code, with no surrounding whitespace added by markup indentation.
    var code = (button.getAttribute('data-dcb-code') || '').trim();
    if (!code) return;

    copyText(code).then(function (ok) {
      if (ok) confirm(button);
    });
  });
})();
